export default "__VITE_ASSET__CZJMbx3G__"